<mat-card appearance="outlined" class="cardBackground">
  <app-snackbar-content-layout>
    <app-snackbar-header-layout>
      <mat-card-title class="titleContainer">{{ "MAIN_APP_DASHBOARD.heutigeTermine" | translate }}</mat-card-title>
      <button
      mat-mini-fab
      color="primary"
      class="fabButton"
      (click)="closeSnackbar()"
    >
      <mat-icon>cancel</mat-icon>
    </button>
    </app-snackbar-header-layout>
    <mat-list *ngFor="let eintrag of terminList">
      <mat-list-item class="listItem">
        <div matListItemTitle>{{eintrag.title}}</div>
        <div matListItemTitle>{{ eintrag.ort }}</div>
        <div matListItemTitle>{{ eintrag.info }}</div>
        <app-snackbar-header-layout>
          <div matListItemLine>{{ eintrag.zeit }} {{ "MAIN_APP_DASHBOARD.uhr" | translate }}</div>
          <button mat-mini-fab color="primary" (click)="showTerminDetail(eintrag)" class="fabButton">
            <mat-icon>edit</mat-icon>
          </button>
        </app-snackbar-header-layout>
      </mat-list-item>
      <mat-divider></mat-divider>
      <div class="fabButtonContainer">
        <button mat-flat-button (click)="showTerminList()" class="flatButton">{{"MAIN_APP_DASHBOARD.alleTermineAnzeigen" | translate}}</button>
      </div>
    </mat-list>
  </app-snackbar-content-layout>
</mat-card>

